module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', {
    staticClass: "history-card",
    attrs: {
      "bordered": false
    }
  }, [_c('p', {
    staticClass: "card-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash-outline"
    }
  }), _vm._v("\n      Histori Hapus\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n              ")])
  }), 1)], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 2
    }
  }, [_c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('Select', {
    attrs: {
      "placeholder": "Branchcode",
      "clearable": ""
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                    " + _vm._s(subbranch.subbranchname) + "\n                ")])
  }), 1)], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 8
    }
  }, [_c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("Periode")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "split-panels": "",
      "placeholder": "Pilih rentang tanggal"
    },
    model: {
      value: (_vm.dateFromTo),
      callback: function($$v) {
        _vm.dateFromTo = $$v
      },
      expression: "dateFromTo"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 4
    }
  }, [_c('div', {
    staticClass: "filter-item"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchButton()),
      expression: "showSearchButton()"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingSearch,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.getPayment
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loadingSearch ? 'Mencari...' : 'Cari'))])])], 1)])], 1)], 1), _vm._v(" "), (_vm.payments.length > 0) ? [_c('Divider', {
    staticStyle: {
      "margin": "0 0 16px"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "summary-bar"
  }, [_c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Total Transaksi : ")]), _vm._v(" "), _c('Tag', {
    staticClass: "summary-tag",
    attrs: {
      "color": "green"
    }
  }, [_vm._v("\n          Rp " + _vm._s(_vm._f("numberFormatted")(_vm.total)) + "\n        ")])], 1), _vm._v(" "), _c('Table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.payments,
      "no-data-text": "",
      "width": "100%",
      "stripe": "",
      "highlight-row": true
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-621d5411","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentDeleteHistory.vue
// module id = 1819
// module chunks = 1